import { OnChanges } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCollection, FilterSingleSelect, FilterValue, FilterValueCollection } from '@hub/generated/models';

@Component({
  selector: 'f-filterSingleSelect',
  templateUrl: './filterSingleSelect.component.html',
  styleUrls: ['./filterSingleSelect.component.scss']
})
export class FilterSingleSelectComponent implements OnInit, OnChanges {
  private readonly defaultEmptyValue: string = '-1';

  constructor() {}

  @Input() public filter: FilterSingleSelect;

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Input() public showEmptyValue: boolean = true;

  @Input() public emptyValueText: string = 'Select...';

  @Output()
  public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

  public value: FilterValue;
  public columnName: string;
  public source: FilterValue[];
  public inline: boolean = true;

  public ngOnInit() {
    this.setValues();
  }

  private setValues() {
    this.columnName = this.filter.ColumnName;
    this.source = [...this.filter.SourceValues];
    if (this.showEmptyValue) {
      let emptyValue: FilterValue = {
        Key: this.defaultEmptyValue,
        Value: this.emptyValueText,
        EntityType: null
      };
      if (!this.source.find(i => i.Value === this.emptyValueText) && !this.source.find(i => i.Key === this.defaultEmptyValue)) {
        this.source.unshift(emptyValue);
      }
    }
    if (this.source.some(i => i.Key === this.defaultEmptyValue)) {
      this.emptyValueText = this.source.find(i => i.Key === this.defaultEmptyValue).Value;
      this.source.sort((a, b) => parseInt(a.Key) < parseInt(b.Key) ? -1 : 1)
    }
    this.value = this.getValue();
  }

  ngOnChanges(){
    this.setValues();
  }

  public onChange() {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    let value: FilterValue = this.value;
    if (this.showEmptyValue && this.value.Key == this.defaultEmptyValue)
      result.List = [];
    else result.List = [value];

    this.ondataChange.emit(result);
  }

  private getValue(): FilterValue {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter(
        item => item.ColumnName == this.columnName
      )[0];
      if (!!values && !!values.List && !!values.List.length)
        return values.List[0];
    }

    return null;
  }
}
